import React, { useState, useEffect, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "./modal.scss";
import OrdersSuperAdmin from "../../../../pages/OrdersSuperAdmin.jsx";
import PanelFormatterHOC from "../../PanelFormatterHOC.tsx";
// import { WaitingOrdersTab } from "../../Orders.tsx";
import { CompletedOrdersTab, WaitingOrdersTab } from "../../Orders.tsx";
import { connection } from "../../../../utils/apiConnection.ts";
import AdminOrdersContext, {
  AdminOrdersProvider,
} from "context/AdminOrdersContext.tsx";
import Acordion from "../../../common/cart/Acordion";
import ShoppingCart from "../../../common/cart/ShoppingCart";
import InternalTransaction from "../../../Transaction/InternalTransaction.jsx";
import AdminOrder from "components/admin-panel/AdminOrders";
import { Orders } from "../../MainPanel.tsx";
import SabadKharid from "../../../layout/SabadKharid.js";

export default function ReportModal({ index }) {
  // const [key, setKey] = useState("orderList");
  // const handleClose = () => setShow(false);
  //   const handleShow = () => setShow(true);
  const { orders, setOrders } = useContext(AdminOrdersContext);
  const [shoppingData, setShoppingData] = useState([]);
  const [updater, setUpdater] = useState(false);
  const [wallet, setWallet] = useState("");
  const [userOrder, setUserOrder] = useState([]);

  // console.log("report index is : ", index);

  // use effect get cart item
  useEffect(() => {
    index &&
      connection("api/getcartitems", { uid: index.users__id }).then((data) => {
        setShoppingData(data.data);
      });
  }, [updater, index]);

  const updateShoppingList = () => {
    setUpdater((prev) => !prev);
  };
  useEffect(() => {
    index &&
      connection("superadminapi/get_wallets", { uid: index.users__id }).then(
        (data) => {
          setWallet(data.data.wallets);
          // console.log("get wallet okkkk! ", wallet);
        }
      );
  }, [index]);
  useEffect(() => {
    index &&
      connection("api/get_all_orders", { uid: index.users__id }).then(
        (data) => {
          setUserOrder(data.data);
          // console.log("user order is :", userOrder);
        }
      );
  }, [index]);
  // useEffect(() => {
  //   // {
  //   //   type == "modal"
  //   //     ?
  // connection("superadminapi/get_wallet_report", {
  //   wallet_id: wallet[index].wallet__id
  // }).then(data => {
  //   setWallet(data.data);
  //   console.log("datainnmmmmm:", data.data);
  // });
  //     : connection("superadminapi/get_wallet_report", {
  //         wallet_id: "1"
  //       }).then(data => {
  //         setWallet(data.data);
  //       });
  // }
  // }, []);

  return (
    <div className="reportModal">
      <div
        className="modal fade "
        id="reportModal"
        tabIndex={-1}
        aria-labelledby="reportModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="reportModalLabel">
                گزارش کاربر
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <ul className="nav nav-tabs mb-4" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="orderList-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#orderList"
                    type="button"
                    role="tab"
                    aria-controls="orderList"
                    aria-selected="true"
                  >
                    لیست سفارشات
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="finance-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#finance"
                    type="button"
                    role="tab"
                    aria-controls="finance"
                    aria-selected="false"
                  >
                    مالی
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="visiting-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#visiting"
                    type="button"
                    role="tab"
                    aria-controls="visiting"
                    aria-selected="false"
                  >
                    بازدیدها
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="shoppingBasket-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#shoppingBasket"
                    type="button"
                    role="tab"
                    aria-controls="shoppingBasket"
                    aria-selected="false"
                  >
                    سبد خرید
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="orderList"
                  role="tabpanel"
                  aria-labelledby="orderList-tab"
                >
                  <ul
                    className=" nav nav-tabs mb-3"
                    id="tabs-tab"
                    role="tablist"
                  >
                    <li className="nav-item mx-4" role="presentation">
                      <button
                        className={`title  nav-link active`}
                        id={`nav-uncompleted-tab`}
                        data-bs-toggle="tab"
                        data-bs-target={`#tabs-uncompleted`}
                        type="button"
                        role="tab"
                        aria-controls={`tabs-uncompleted`}
                        aria-selected="true"
                        key={`admin-panel-tab-buttons-uncompleted`}
                      >
                        سفارشات در حال انتظار
                      </button>
                    </li>
                    <li className="nav-item mx-4" role="presentation">
                      <button
                        className={`title  nav-link `}
                        id={`nav-completed-tab`}
                        data-bs-toggle="tab"
                        data-bs-target={`#tabs-completed`}
                        type="button"
                        role="tab"
                        aria-controls={`tabs-completed`}
                        aria-selected="true"
                        key={`admin-panel-tab-buttons-completed`}
                      >
                        سفارشات تکمیل شده
                      </button>
                    </li>
                  </ul>
                  <div className="body tab-content">
                    <div
                      class={`tab-pane fade show active`}
                      id={`tabs-uncompleted`}
                      role="tabpanel"
                      aria-labelledby={`nav-uncompleted-tab`}
                      key={`admin-panel-tabs-uncompleted`}
                    >
                      <WaitingOrdersTab
                        orders={userOrder?.filter(
                          (value) => value.lats_order_status != 4
                        )}
                      />
                    </div>
                    <div
                      class={`tab-pane fade show active`}
                      id={`tabs-completed`}
                      role="tabpanel"
                      aria-labelledby={`nav-completed-tab`}
                      key={`admin-panel-tabs-completed`}
                    >
                      <CompletedOrdersTab
                        orders={userOrder?.filter(
                          (value) => value.lats_order_status == 4
                        )}
                      />
                    </div>
                  </div>

                  {/* <PanelFormatterHOC
                    title={["سفارشات درحال انتظار", "سفارشات تکمیل شده"]}
                    label="orders"
                    components={[
                      <WaitingOrdersTab
                        orders={userOrder.filter(
                          (value) => value.lats_order_status != 4
                        )}
                      />,
                      <CompletedOrdersTab
                        orders={userOrder.filter(
                          (value) => value.lats_order_status == 4
                        )}
                      />,
                    ]}
                  /> */}
                  {/* <AdminOrdersProvider>
                    <Orders />
                  </AdminOrdersProvider> */}
                </div>
                {}
                <div
                  className="tab-pane fade"
                  id="finance"
                  role="tabpanel"
                  aria-labelledby="finance-tab"
                >
                  {wallet && index.users__id != "" && (
                    <InternalTransaction
                      walletId={wallet[index.users__id].wallets__id}
                      type="modal"
                    />
                  )}
                </div>
                <div
                  className="tab-pane fade"
                  id="visiting"
                  role="tabpanel"
                  aria-labelledby="visiting-tab"
                >
                  visited
                </div>
                <div
                  className="tab-pane fade"
                  id="shoppingBasket"
                  role="tabpanel"
                  aria-labelledby="shoppingBasket-tab"
                >
                  {/* <SabadKharid /> */}
                  <div className="px-3 pb-2 mb-2 w-100">
                    {shoppingData.length > 0 &&
                      shoppingData.map((value) =>
                        value.rto_basket_id == "0" ? (
                          <ShoppingCart
                            data={value}
                            updateShoppingList={updateShoppingList}
                            typeee="0"
                          />
                        ) : (
                          <Acordion
                            data={value}
                            updateShoppingList={updateShoppingList}
                            typeee="0"
                          />
                        )
                      )}
                  </div>
                  {/* <Acordion */}
                  {/* // updateShoppingList={1} index={2} data={3} */}
                  {/* // /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
